import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getHeaders } from "../utils/helper";

export const locationServerApi = createApi({
  reducerPath: "locationServerApi",
  baseQuery: fetchBaseQuery({ baseUrl: process?.env?.REACT_APP_API_HOST_URL }),
  tagTypes: ["Location"],
  endpoints: (builder) => ({
    getState: builder.query({
      query: () => ({
        url: "/core/states",
        headers: getHeaders(),
      }),
      providesTags: ["Location"],
    }),
  }),
});

export const { useGetStateQuery } = locationServerApi;
